import React from 'react'
import PropTypes from 'prop-types'
import { StaticImage } from 'gatsby-plugin-image'
import { useTheme } from 'styled-components'
import { useIntl } from 'react-intl'

import { ArrowCircle, Container } from '../styles/PageLayout'
import { BodyM, TitleM } from '../styles/Typography'
import { VideosStyled } from '../styles/components/VideosStyled'

import Arrow from './icons/arrow'

/**
 * The videos block.
 * @param {ComponentProps} props
 * @param {string|Array} props.title
 * @returns {FunctionComponent}
 */
const Videos = ({ title }) => {
  const intl = useIntl()
  const theme = useTheme()

  return (
    <VideosStyled>
      <Container $column $mobileColumn $alignItems="center">
        <TitleM className="title">{title}</TitleM>
      </Container>
      <div className="videos-wrapper">
        <div className="videos-row upper">
          <a className="video large video-1" href="https://youtube.com/watch?v=HwQQjUIlcSo" target="_blank">
            <div className="overlay">
              <ArrowCircle>
                <Arrow />
              </ArrowCircle>
              <BodyM $color={theme.textLight}>{intl.formatMessage({ id: 'block_videos_text_1' }, { br: <br /> })}</BodyM>
            </div>
          </a>
          <div className="videos-column">
            <a className="video mid upper video-2" href="https://youtu.be/1Y33P5W2ksM" target="_blank">
              <div className="overlay">
                <ArrowCircle>
                  <Arrow />
                </ArrowCircle>
                <BodyM $color={theme.textLight}>{intl.formatMessage({ id: 'block_videos_text_1' }, { br: <br /> })}</BodyM>
              </div>
            </a>
            <div className="videos-group upper">
              <a className="video small video-3" href="https://youtube.com/watch?v=1e_F_-h4rfY" target="_blank">
                <div className="overlay">
                  <ArrowCircle>
                    <Arrow />
                  </ArrowCircle>
                  <BodyM $color={theme.textLight}>{intl.formatMessage({ id: 'block_videos_text_1' }, { br: <br /> })}</BodyM>
                </div>
              </a>
              <a className="video small video-4" href="https://youtu.be/WHa1vZxsBZQ" target="_blank">
                <div className="overlay">
                  <ArrowCircle>
                    <Arrow />
                  </ArrowCircle>
                  <BodyM $color={theme.textLight}>{intl.formatMessage({ id: 'block_videos_text_1' }, { br: <br /> })}</BodyM>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div className="videos-row lower">
          <div className="videos-group lower">
            <a className="video small video-5" href="https://youtu.be/HOCLq3A9O-8" target="_blank">
              <div className="overlay">
                <ArrowCircle>
                  <Arrow />
                </ArrowCircle>
                <BodyM $color={theme.textLight}>{intl.formatMessage({ id: 'block_videos_text_1' }, { br: <br /> })}</BodyM>
              </div>
            </a>
            <a className="video small video-6" href="https://youtu.be/WHa1vZxsBZQ" target="_blank">
              <div className="overlay">
                <ArrowCircle>
                  <Arrow />
                </ArrowCircle>
                <BodyM $color={theme.textLight}>{intl.formatMessage({ id: 'block_videos_text_1' }, { br: <br /> })}</BodyM>
              </div>
            </a>
          </div>
          <a className="video mid lower video-7" href="https://youtu.be/5owy4ZWvjXw" target="_blank">
            <div className="overlay">
              <ArrowCircle>
                <Arrow />
              </ArrowCircle>
              <BodyM $color={theme.textLight}>{intl.formatMessage({ id: 'block_videos_text_1' }, { br: <br /> })}</BodyM>
            </div>
          </a>
        </div>
      </div>
    </VideosStyled>
  )
}

Videos.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
}

export default Videos
